export default class BootstrapModalComponent {
    constructor() {
        $('body').append(`<div class="modal fade" id="modal-details" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modal-details-title"></h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <i class="zmdi zmdi-close"></i>
              </button>
            </div>
            <div class="modal-body" id="modal-details-body">
              ...
            </div>
          </div>
        </div>
      </div>`);
    }
}